// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_7rC","cls2":"ArticlesFilters-cls2_wtk ArticlesFilters-cls1_7rC","selected":"ArticlesFilters-selected_Pf0"};